import React from 'react'
import im from './img/number1.png'
import ima from './img/number2.png'
import imaa from './img/numbre3.png'
import b from './img/one.png'
import bb from './img/two.png'
import bbb from './img/three.png'
///import bbbb from './img/dot.png'
import g from './img/substract.png'
import './Business.css';
import { Container } from 'react-bootstrap';
import Rotate from 'react-reveal/Rotate';












export const Business = () => (
  <Container>


 <div style={styles.container}>
      <Rotate top right>
        <div style={styles.wrapper}>
          
          {/* כותרות ראשיות כשלבים */}
          <div style={styles.stepsContainer}>
            <div style={styles.stepCard}>
              <h2 style={styles.mainHeader}>
                חוות דעת משרד הבריאות לתכנון העסק 
                <img style={styles.icon} src={im} alt="2"/>
              </h2>
            </div>

            <div style={styles.stepCard}>
              <h2 style={styles.mainHeader}>
                הגשת הבקשה לרישיון העסק 
                <img style={styles.icon} src={ima} alt="2"/> 
              </h2>
            </div>

            <div style={styles.stepCard}>
              <h2 style={styles.mainHeader}>
                בדיקת תקינות וטיפול מול מחלקת הנדסה לעסקים
                <img style={styles.icon} src={imaa} alt="2"/>
              </h2>
            </div>
          </div>

          {/* יחידות הנדסה */}
          <div style={styles.infoSection}>
            <h4 style={styles.subTitleHighlight}>
              <img src={g} alt="2" style={{marginLeft: '10px', width: '30px'}}/>
              מחלקת הנדסה לעסקים מחולקת לשתי יחידות: 
              <br/>
              <span style={{color: '#3498db'}}>יחידת תכנון הנדסי ויחידת רישוי הנדסי</span>
            </h4>

            <div style={styles.grid}>
              <div style={styles.unitBox}>
                <h3 style={styles.unitHeader}><img style={styles.smallIcon} src={b} alt="2"/>
                   - היחידה לתכנון הנדסי 
                </h3>
                <p style={styles.text}>
                  מטפלת בתכניות לניהול עסק שהוגשו על ידי בעל מקצוע מוסמך, לפי חוק רישוי עסקים. 
                  המחלקה בודקת את תכנון העסק, חלוקת מדורים, שטחים הנדרשים לעסק, 
                  נגישות לאנשים עם מוגבלויות ותכנית לפרגוד.
                </p>
              </div>

              <div style={styles.unitBox}>
                
                <h3 style={styles.unitHeader}><img style={styles.smallIcon} src={bb} alt="2"/>
                   - היחידה לרישוי הנדסי 
                </h3>
                <p style={styles.text}>
                  בודקת את חוקיות המבנה לפי חוק התכנון והבנייה והיתר בנייה (תב"ע). 
                  במידה והשימוש אינו תואם להיתר, המחלקה תפנה את הבקשה להליך שימוש חורג ביחידת רישוי הנדסי.
                </p>
              </div>
            </div>
          </div>

          {/* מחלקת ביקורת */}
          <img style={styles.smallIcon} src={bbb} alt="2"/>
          <div style={styles.auditSection}>
            <h3 style={styles.unitHeader}>
              מחלקת ביקורת עסקים 
            </h3>
            <p style={styles.text}>
              המחלקה מבצעת ביקורות בעסקים לבדיקת התאמה לתכנית המאושרת ותנאי תברואה נאותים. 
              באתר העירייה ניתן למצוא את המפרט האחיד, טיפים וטפסי צ'ק ליסט להכנה לקראת הביקורת.
            </p>
          </div>

        </div>





 






  </Rotate>
   </div>



   </Container>




)


const styles = {
  container: {
    direction: 'rtl',
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    padding: '40px 20px',
    backgroundColor: '#f8f9fa',
    minHeight: '100vh'
  },
  wrapper: {
    maxWidth: '900px',
    margin: '0 auto',
  },
  stepsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    marginBottom: '40px'
  },
  stepCard: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
    borderRight: '5px solid #3498db'
  },
  mainHeader: {
    fontSize: '1.4rem',
    color: '#2c3e50',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  subTitleHighlight: {
    textAlign: 'center',
    fontSize: '1.2rem',
    lineHeight: '1.6',
    color: '#2c3e50',
    marginBottom: '30px',
    padding: '20px',
    backgroundColor: '#e1f5fe',
    borderRadius: '10px'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px',
    marginBottom: '30px'
  },
  unitBox: {
    backgroundColor: '#fff',
    padding: '25px',
    borderRadius: '12px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.03)',
  },
  unitHeader: {
    color: '#2980b9',
    fontSize: '1.3rem',
    marginBottom: '15px',
    borderBottom: '1px solid #eee',
    paddingBottom: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  text: {
    color: '#7f8c8d',
    lineHeight: '1.8',
    fontSize: '1rem',
    margin: 0
  },
  auditSection: {
    backgroundColor: '#fff',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.03)',
    borderTop: '5px solid #2ecc71'
  },
  icon: {
    width: '45px',
    height: '45px',
    objectFit: 'contain'
  },
  smallIcon: {
    width: '30px',
    height: '30px'
  }
};